export default __webpack_public_path__ + "static/media/Add-a-subheading-3-1.cdbd6a46.png";